import {
	CONFIRM_PERIOD_NOTIFICATION_COMPLETE,
	CREATE_STATS_COMPLETE,
	DELETE_STATS_COMPLETE,
	FINALIZE_GAME_COMPLETE,
	FINISH_PERIOD_COMPLETE,
	GET_STATS_COMPLETE,
	PAUSE_COMPLETE,
	PLAY_COMPLETE,
	SET_OVERTIME_NOTIFICATION_COMPLETE,
	SET_TIME_AND_PERIOD,
	SET_TIME_AND_PERIOD_COMPLETE,
	SET_TIME_AND_PERIOD_ERROR,
	SET_TIME_COMPLETE,
	SHOW_TIME_CONFIG,
	START_PERIOD_COMPLETE,
	SWAP_TEAMS_COMPLETE,
	UPDATE_STATS_COMPLETE,
	VALIDATE_GAME_DATA,
	VALIDATE_GAME_DATA_COMPLETE,
	SAVE_MATCHES_FINALIZATION_ORDER,
	SAVE_MATCHES_FINALIZATION_ORDER_COMPLETE,
	KEEP_SWAPPING_TEAMS_COMPLETE,
	ORDER_PLAYERS_BY_POSITION_COMPLETE,
	SAVE_FINALIZATION_SETTINGS_COMPLETE,
	GET_PROMPT_RECEIVING_TEAM_COMPLETE,
	UPDATE_RECEIVING_TEAM_COMPLETE
} from "./constants";

const initialState = {
	isLoading: false,
	gameId: null,
	periods: [],
	gameClock: { now: null, elapsedTime: 0 },
	homeScore: 0,
	visitorScore: 0,
	timeouts: {},
	yardsToFirstDown: 0,
	fieldPosition: 0,
	fieldPositionFormatted: null,
	homeTeamHasPossession: false,
	firstDownAt: 0,
	gameConfig: null,
	teamContexts: {},
	jsonStats: {},
	down: 0,
	startSettings: {
		tossWinner: null,
		offenseTeam: null
	},
	gameInitialized: false,
	finalizeSettings: {},
	validationErrors: [],
	showTimeConfig: false,
	missingGameData: [],
	swapTeams: false,
	orderPlayersByPosition: true,
	keepSwappingTeams: false,
	triggerSwapTeams: false,
	triggerNewPeriodNotification: false,
	triggerKO: false,
	fbOtDisabled: false,
	promptReceivingTeam: false,
	// Mirrored from core's gameContext via UPDATE_STATS_COMPLETE payloads;
	// "running" means the game uses the real-time clock.
	clockType: "manual"
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case VALIDATE_GAME_DATA:
		case SAVE_MATCHES_FINALIZATION_ORDER: {
			return {
				...state,
				isLoading: true
			};
		}
		case UPDATE_STATS_COMPLETE:
		case CREATE_STATS_COMPLETE:
		case GET_STATS_COMPLETE:
		case START_PERIOD_COMPLETE:
		case FINISH_PERIOD_COMPLETE:
		case SET_TIME_COMPLETE:
		case PLAY_COMPLETE:
		case PAUSE_COMPLETE:
		case FINALIZE_GAME_COMPLETE:
		case SAVE_FINALIZATION_SETTINGS_COMPLETE:
		case SET_TIME_AND_PERIOD:
		case SET_TIME_AND_PERIOD_COMPLETE:
		case SET_OVERTIME_NOTIFICATION_COMPLETE: {
			return {
				...state,
				...payload,
				validationErrors: [],
				showTimeConfig: false,
				isLoading: false
			};
		}
		case SET_TIME_AND_PERIOD_ERROR: {
			return {
				...state,
				...payload,
				isLoading: false
			};
		}
		case DELETE_STATS_COMPLETE: {
			return {
				...state,
				...initialState,
				validationErrors: [],
				isLoading: false
			};
		}
		case SHOW_TIME_CONFIG: {
			return {
				...state,
				...payload,
				validationErrors: [],
				isLoading: false
			};
		}
		case VALIDATE_GAME_DATA_COMPLETE: {
			return {
				...state,
				...payload,
				isLoading: false
			};
		}
		case UPDATE_RECEIVING_TEAM_COMPLETE:
		case GET_PROMPT_RECEIVING_TEAM_COMPLETE:
		case SWAP_TEAMS_COMPLETE:
		case ORDER_PLAYERS_BY_POSITION_COMPLETE:
		case KEEP_SWAPPING_TEAMS_COMPLETE:
		case CONFIRM_PERIOD_NOTIFICATION_COMPLETE:
		case SAVE_MATCHES_FINALIZATION_ORDER_COMPLETE: {
			return {
				...state,
				...payload,
				isLoading: false
			};
		}
		default:
			return state;
	}
};

export default reducer;
